import { render, staticRenderFns } from "./LProjectGroupObject.vue?vue&type=template&id=b0630190&scoped=true&"
import script from "./LProjectGroupObject.vue?vue&type=script&lang=js&"
export * from "./LProjectGroupObject.vue?vue&type=script&lang=js&"
import style0 from "./LProjectGroupObject.vue?vue&type=style&index=0&id=b0630190&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0630190",
  null
  
)

export default component.exports